export function KioskBlank() {
  return <div className="h-screen w-screen bg-black" />;
}
